export function PremadeChip(props: { visible: boolean }) {
  if (!props.visible) return null;
  return (
    <span style={{
      background: 'var(--sage)', color: 'var(--sage-text)',
      fontSize: 11, padding: '1px 7px', borderRadius: 4, fontWeight: 600,
    }}>premade</span>
  );
}
